/*-----------------------------------------------------------------
- Blog Page
-----------------------------------------------------------------*/

export default {
    title             : 'MVP',
    icon_alt          : 'icon',
    faq_title         : 'Answers to Your Questions',
    case_studies_title: 'Explore Real World Use Cases and Success Stories',
};
